import { atom } from "recoil";

export const editDataState = atom({
  key: "editDataState",
  default: [],
});
